import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function interactiveshowcase() {

	let interactiveSwiper = new Swiper(".interactiveSwiper", {
		loop: false,
		slidesPerView: 'auto',
		modules: [Navigation, Pagination],
		scrollbar: {
			el: ".swiper-scrollbar",
			draggable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		spaceBetween: 50,
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 2.5,
			},
		},
	});

	const backgroundDot = document.getElementById('backgroundDot');
	const firstShowcase = document.querySelector('.showcase');
	const firstPicker = document.querySelector('.color_picker');

	if (firstShowcase) {
		firstShowcase.classList.add('active');
	}
	if (firstPicker) {
		firstPicker.classList.add('active');
	}

	if (backgroundDot) {
		backgroundDot.style.backgroundColor = firstShowcase.getAttribute('data-color');
	}


	document.querySelectorAll('.color_picker').forEach(picker => {
		picker.addEventListener('click', () => {
			const color = picker.getAttribute('data-color');

			backgroundDot.style.backgroundColor = color;

			document.querySelectorAll('.showcase').forEach(showcase => {
				showcase.classList.remove('active');
			});

			document.querySelectorAll('.color_picker').forEach(showcase => {
				showcase.classList.remove('active');
			});

			picker.classList.add('active');

			const targetShowcase = document.querySelector(`.showcase[data-color="${color}"]`);
			targetShowcase.classList.add('active');
		});
	});
}

export {interactiveshowcase};
